module.exports = __webpack_public_path__ + "img/img4.a59d8cc5.svg";